export const CONTEST_POSTER_SRC = '/konkurs/gadzety-dolny-slask.png'
export const CONTEST_NEWS_PATH = '/o-projekcie/aktualnosci?tab=konkurs'
export const CONTEST_POPUP_DISMISSED_KEY = 'pds-contest-promo-popup-dismissed'
export const CONTEST_POPUP_DELAY_MS = 1600
